// extracted by mini-css-extract-plugin
export var menu = "NavigationMenu-module--menu--2NQml";